import actions from './actions';
import mutations from './mutations.js';
import getters from './getters.js';


const state = {
    groupData: {},
    operations: [],
    otherOperations: [],
    departments: [],
    modalContext: {},
    lastGroup: {},
    source: {},
    defaultCurrency: {},
    errors: [],
    method: '',
    returnUrl: '',
    addContractorsUrl: '',
    useExchangeRates: false,
    modalCheckboxes: {},
    stateToCommit: {
        operations: [],
        otherOperations: []
    },
    dynamicContent : {},
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters,
}
